import styled from "styled-components";
import {flexColumnContainerMixin, flexRowContainerMixin} from "../../../../../themes/architecture/css-helpers/flex";

export const OptInDialogFooterBox = styled.div`
    @media ${({theme}) => `${theme.mediaQuery.xlAndAbove} or ${theme.mediaQuery.landscape}`} {
        ${flexRowContainerMixin}
    }
    ${flexColumnContainerMixin}

    display: flex;
    align-items: center;
    background:${props => props.theme.colors.backgroundMiddleDark};
    padding: 16px 24px
`